import React, { lazy } from 'react'
import { Grid, Image, Loader } from 'semantic-ui-react'
import './Series.scss'
import {map} from 'lodash'
import db, { storage } from '../../utils/firebase'
import {Link, withRouter} from 'react-router-dom'
import { connect } from 'react-redux'
import InfiniteScroll from 'react-infinite-scroll-component'
import { moreSeries } from '../../utils/Validations'
import { toast } from 'react-toastify'


 function Series() {

    const [listaSeleccionada,setListaSeleccionada]= React.useState({value:""})
    const [peliculas,setPeliculas]=React.useState()
    const [startPeliculas,setStartPeliculas] = React.useState()
    const [hasMore,setHasMore] = React.useState(true)

    const limite = 20

    const opciones=[
       // {key: "1", text: "accion", value: "accion"},
       // {key: "2", text: "romance", value: "romance"},
       // {key: "3", text: "terror", value: "terror"},
        {key: "4", text: "comedia", value: "comedia"},
        {key: "5", text: "drama", value: "drama"},
      //  {key: "6", text: "adolescentes", value: "adolescentes"},
      //  {key: "7", text: "ciencia ficcion", value: "ciencia ficcion"},
      //  {key: "8", text: "documentales", value: "documentales"},
     //   {key: "9", text: "aventura", value: "aventura"},


    ]


    React.useEffect(()=>{
        if(listaSeleccionada.value){

            let result = db.collection("series").where("type","==",listaSeleccionada.value).orderBy("createAt","desc").limit(limite)
            result.get().then((response)=>{
    
                setStartPeliculas(response.docs[response.docs.length-1])
    
                if(response.docs.length > 0){
    
                    const res =  response.docs.map((doc)=>{
                        const data = doc.data()
                        return{
                            ...data
                        }
                    })
        
                    setPeliculas(res)
                }else{
                }
            })   
        }else{
            let result = db.collection("series").orderBy("createAt","desc").limit(limite)
            result.get().then((response)=>{
    
                setStartPeliculas(response.docs[response.docs.length-1])
    
                if(response.docs.length > 0){
    
                    const res =  response.docs.map((doc)=>{
                        const data = doc.data()
                        return{
                            ...data
                        }
                    })
        
                    setPeliculas(res)
                }
            })  

        }

        


    },[listaSeleccionada.value])

    const handleVerMas =  ()=>{
        setTimeout(async()=>{

            if(!startPeliculas){
                setHasMore(false)
              //  setLoadingMore(false)
    
                return
            }
            /// setLoading(true)
            const response = await moreSeries(limite,startPeliculas)
            if(response.statusResponse){
                setStartPeliculas(response?.startSeries)
                setPeliculas([...peliculas,...response?.series])
                //setLoadingMore(false)
    
            }else{
    
              //  setLoadingMore(false)
            }
            // setLoading(false)
        },500)

    }




    return (
        <div className="series-banner" >
            {
                peliculas?.length>0 && 
                <InfiniteScroll
                dataLength={peliculas.length}
                className='infiniti'
                
                next={()=>handleVerMas()}
                    hasMore={hasMore}
                    scrollableTarget="scrollableDiv"
                >
                    <Grid>
                        <Grid.Row columns="6" only="computer" >
                            {
                                map(peliculas, item =>(
                                    <RenderSeries key={item.uuidPoster} item={item} />
                                ))
                            }
                        </Grid.Row>
                        <Grid.Row columns="6" only="tablet" >
                            {
                                map(peliculas, item =>(
                                    <RenderSeries key={item.uuidPoster} item={item} />
                                ))
                            }
                        </Grid.Row>
                        <Grid.Row columns="3" only="mobile" >
                            {
                                map(peliculas, item =>(
                                    <RenderSeries key={item.uuidPoster} item={item} />
                                ))
                            }
                        </Grid.Row>
                    </Grid>

                </InfiniteScroll>
            }
           
        </div>
    )
}



export default withRouter(Series)

function RenderSeries(props){

    const{item}=props

    

    return (

        <Grid.Column>
            <Link to={`/serie/${item.uuidPoster}`} >
                <Image isLoading={lazy} src={item.urlPoster} />
                <h2>{item?.title}</h2>
            </Link>
        </Grid.Column>

    )
}

